import { Injectable, Injector } from '@angular/core';
import { Course } from 'core/models/course';
import { CoursesService } from 'core/services/courses.service';
import { HttpDataService } from 'core/services/http-data.service';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class DemosService extends HttpDataService {
  private demoCourses: [Course];

  constructor(protected injector: Injector, private coursesService: CoursesService) {
    super(injector, '/core/sales/demos');
  }

  loadDemoCoursesCache() {
    if (this.demoCourses && this.demoCourses.length) {
      return Promise.resolve(this.demoCourses);
    }
    return this.coursesService.getDemoCourses().then((demoCourses: [Course]) => {
      this.demoCourses = demoCourses;
    });
  }

  getDemoCourseOptions() {
    const demoCourses = this.demoCourses;
    return demoCourses
      ? demoCourses.map((demoCourse) => ({
          key: demoCourse.id,
          value: demoCourse.name,
          data: demoCourse
        }))
      : [];
  }

  getDemo(id: string) {
    const url = `${this.baseUrl}/${id}`;
    return lastValueFrom(this.http.get(url, this.getRequestOptions()))
      .then((response) => response)
      .catch((error) => this.handlePromiseError(error));
  }

  getDistributorDemosQuota(id: string): Promise<any> {
    const url = `${this.baseUrl}/${id}/demos-quota`;
    return lastValueFrom(this.http.get(url, this.getRequestOptions()))
      .then((response) => response)
      .catch((error) => this.handlePromiseError(error));
  }

  extend(prospectId: string, props: any) {
    const url = `${this.baseUrl}/${prospectId}`;
    return super.putRequest(url, JSON.stringify(props), this.getRequestOptions());
  }
}
